import React from "react";
import { useTranslation } from "react-i18next";

const certificatesData = {
  logos: [
    {
      altKey: "bisAlt", // Key for translation
      src: "/assets/images/Certificates/bis.png",
      width: 158,
      height: 30,
      classes: "col-span-2 max-h-13 w-full object-contain lg:col-span-1",
    },
    {
      altKey: "sgllt",
      src: "/assets/images/Certificates/sgl.png",
      width: 158,
      height: 48,
      classes: "col-span-2 max-h-13 w-full object-contain lg:col-span-1",
    },
    {
      altKey: "igiAlt",
      src: "/assets/images/Certificates/IGI.webp",
      width: 158,
      height: 48,
      classes: "col-span-2 max-h-13 w-full object-contain lg:col-span-1",
    },
    {
      altKey: "giaAlt",
      src: "/assets/images/Certificates/GIA.webp",
      width: 158,
      height: 48,
      classes: "col-span-2 max-h-13 w-full object-contain sm:col-start-2 lg:col-span-1",
    },
  ],
};

const Certificates = () => {
  const { t } = useTranslation("certificates"); // Translation hook

  return (
    <div className="bg-white py-24 sm:py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h1 className="text-center text-3xl font-bold leading-8 text-gray-900">
          {t("title")} {/* Translate title */}
        </h1>
        <div
          className="mx-auto mt-10 grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-4"
          data-aos="fade-down"
        >
          {certificatesData.logos.map((logo, index) => (
            <img
              key={index}
              alt={t(logo.altKey)} // Translate alt text
              src={logo.src}
              width={logo.width}
              height={logo.height}
              className={logo.classes}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Certificates;
